module.exports = __webpack_public_path__ + "img/mirror04.3b68caca.jpg";